import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import { TRAVEL_HEALTH_NXT_CONSTANTS } from '@flows/configs/travelHealthNxt/constants'
import { familyMemberSchema } from '@flows/configs/travelHealthNxt/steps/familyMembers/family_member_schemas'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'

const family_members = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('insured_family_members')]: familyMemberSchema
        .array()
        .nonempty(),
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_travelHealth:steps.family_members.title',
        },
      },
      {
        type: 'editableList',
        maximumItems: TRAVEL_HEALTH_NXT_CONSTANTS.MAXIMUM_FAMILY_MEMBERS,
        name: params.helperFunctions.getParamPath('insured_family_members'),
        addItemLabel: {
          type: 'translatableText',
          translationKey: 'sharedFlows_travelHealth:steps.family_members.start.add_member',
        },
        startText: {
          type: 'translatableText',
          translationKey: 'sharedFlows_travelHealth:steps.family_members.start.text',
        },
        title: {
          type: 'translatableText',
          translationKey: 'sharedFlows_travelHealth:steps.family_members.start.title',
        },
        editableListItemTitleKey: 'first_name',
        popupConfiguration: {
          title: {
            type: 'translatableText',
            translationKey: 'sharedFlows_travelHealth:steps.family_members.popup.title',
          },
          schema: familyMemberSchema,
          elements: [
            {
              type: 'input',
              name: 'first_name',
              label: {
                type: 'translatableText',
                translationKey: 'sharedFlows_travelHealth:steps.family_members.first_name',
              },
            },
            {
              type: 'input',
              name: 'last_name',
              label: {
                type: 'translatableText',
                translationKey: 'sharedFlows_travelHealth:steps.family_members.last_name',
              },
            },
            {
              type: 'date',
              name: 'born_on',
              maxDate: 'now',
            },
            {
              type: 'dropDown',
              name: 'relationship_type',
              useFilterInput: false,
              styleType: 'outlined',
              label: {
                type: 'translatableText',
                translationKey: 'sharedFlows_travelHealth:steps.family_members.relationship_type',
              },
              options: TRAVEL_HEALTH_NXT_CONSTANTS.relationshipTypeOptions,
            },
          ],
        },
      },
    ],
    nextStep: 'travel_quote',
    subFlow: params.subFlow,
  }) as const satisfies AnyStepConfiguration

export default family_members
